module.exports = __webpack_public_path__ + "fonts/elephant-regular.ce42f4a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/retro-baby/fonts/elephant-regular.woff
// module id = 398
// module chunks = 0